var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',_vm._l((_vm.rows || 4),function(ii){return _c('tr',{key:ii},_vm._l((_vm.cols),function(i){return _c('td',{key:i},[_c('PreloadBlock')],1)}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }